import { MODELS, useModel } from "../../../api";
import useToggle from "../../../hooks/useToggle.js";
import OpenDropdown from "./OpenDropdown/OpenDropdown.jsx";
import { OpenedDropdown } from "./OpenedDropdown/OpenedDropdown.jsx";

/**
 * Dropdown component to render a dropdown button with a customizable overlay.
 * This component utilizes user data and interactive state management to toggle the visibility of the dropdown.
 *
 * @param {Object} props - The props object.
 * @param {string} props.linkHost - The host link utilized within the opened dropdown.
 * @param {boolean} [props.withLogo=true] - Flag indicating whether to display the company logo in the dropdown button.
 * @param {string} [props.avatarSize="30px"] - The size of the avatar displayed.
 * @return {JSX.Element|null} A JSX element representing the dropdown component, or null if user data is not available.
 */
export function Dropdown({ linkHost, withLogo = true, avatarSize = "30px" }) {
  const me = useModel(MODELS.ME);
  const [open, { toggle }] = useToggle();

  if (!me) return null;

  return (
    <OpenDropdown
      avatarSize={avatarSize}
      withLogo={withLogo}
      me={me}
      overlayComponent={OpenedDropdown}
      overlayData={{ me, linkHost }}
      open={open}
      toggle={toggle}
      size="xl"
    />
  );
}
